import {
  AtSkeleton,
  MlNote,
  MlTableMessage,
} from "@csc-dashboard/components-library";
import { useAdminPanel } from "../context/admin-panel";

export const NotesComponent = () => {
  const { notes, isLoading } = useAdminPanel();
  const { setCurrentTab } = useAdminPanel();

  if (notes && notes.length === 0) {
    return (
      <MlTableMessage
        darkerDescription
        size="mini"
        title="No hay notas para mostrar"
        description="Cuando crees una nota, podrás verla aquí."
      />
    );
  }

  if (isLoading) {
    return (
      <div className="flex flex-col gap-4">
        <AtSkeleton variant="rectangular" width={384} height={180} />
        <AtSkeleton variant="rectangular" width={384} height={180} />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 overflow-hidden">
      {notes.map((note) => (
        <div key={note.id}>
          <MlNote
            modifiedAt={note.modifiedAt}
            action={{
              text: "Editar",
              onClick: () =>
                setCurrentTab("notes-form", {
                  noteId: note.id,
                  noteBody: note.body,
                }),
            }}
            noteVariant="compact"
            title={note.title}
            body={note.body}
            createdBy={note.userName}
            createdAt={note.createdAt}
            id={note.id}
          />
        </div>
      ))}
    </div>
  );
};
